// extracted by mini-css-extract-plugin
export default {"page":"ZP-z","cartModal":"_P-z","checkout":"aQ-z","placeholder":"bQ-z","account":"cQ-z"};